<template>
  <card class="card-user">
    <div slot="image">
      <img v-if="data.profile_picture && data.profile_picture.path" :src="`${imageUrl}/${data.profile_picture.path}`">
      <img v-else class="default" src="../../../src/assets/img/default-profile.png" >
    </div>
    <div>
      <div class="author">
        <h4 class="title"> {{this.data.name}}
          <br>
<!--          <a href="#">-->
            <small dir="ltr">@{{data.username || '---'}}</small>
<!--          </a>-->
        </h4>
      </div>
<!--      <p class="description text-center">-->
<!--        "I like the way you work it-->
<!--        <br> No diggity-->
<!--        <br> I wanna bag it up"-->
<!--      </p>-->
    </div>
    <!--    <hr>-->
    <!--    <div class="text-center">-->
    <!--      <div class="row">-->
    <!--        <div v-for="(info, index) in details" :key="index">-->
    <!--          <h5>{{info.title}}-->
    <!--            <br>-->
    <!--            <small>{{info.subTitle}}</small>-->
    <!--          </h5>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
  </card>
</template>
<script>
  import {API_MEDIA_URL} from '../../env'

  export default {
    props: {
      data: {
        type: Object,
        default: {},
      }
    },
    data() {
      return {
        imageUrl: API_MEDIA_URL,
        details: [
          {
            title: "12",
            subTitle: "Files"
          },
          {
            title: "2GB",
            subTitle: "Used"
          },
          {
            title: "24,6$",
            subTitle: "Spent"
          }
        ]
      };
    },
    methods: {}
  };
</script>
<style>
</style>
